import {URL_BASE_API } from '../../configs/urlConfigs'; 
import {LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, LOGIN_CREW_GROUP} from '../../configs/staticConfigs';

import service from '../api';

export const dynamicFieldsList = (request) => {
    let ENDPOINT = '';
    // {groupId: 0, reqFrom:0}
    if(request.data.reqFrom===LOGIN_SUPER_ADMIN_GROUP) {
        // FROM SUPERADMIN 
        ENDPOINT = URL_BASE_API+'super-admin/dynamic-fields/?column=display_order&search='+request.data.groupId;
    }
    else if(request.data.reqFrom===LOGIN_AFFILIATE_GROUP && request.data.groupId===LOGIN_AFFILIATE_GROUP) {
        // FROM AFFILIATE LOGIN - AFFILIATE PROFILE (From Settings)
        //ENDPOINT = URL_BASE_API+'super-admin/dynamic-fields/?column=display_order&show_tab=true&search='+request.data.groupId; 
        ENDPOINT = URL_BASE_API+'affiliate/dynamic-field/?column=display_order&show_tab=true&search='+request.data.groupId; 
    }
    else if(request.data.reqFrom===LOGIN_AFFILIATE_GROUP && request.data.groupId===LOGIN_CLIENT_GROUP) {
        // FROM AFFILIATE LOGIN - CLIENT PROFILE (ADD/EDIT FROM AFFILIATE CLIENT LISTING) 
        ENDPOINT = URL_BASE_API+'affiliate/dynamic-field/?column=display_order&search='+request.data.groupId;  // display_order
    } 
    else if(request.data.reqFrom===LOGIN_AFFILIATE_GROUP && request.data.groupId===LOGIN_CREW_GROUP) {
        // FROM AFFILIATE LOGIN - CLIENT PROFILE (ADD/EDIT FROM AFFILIATE CLIENT LISTING) 
        ENDPOINT = URL_BASE_API+'affiliate/dynamic-field/?column=display_order&search='+request.data.groupId;  
    } 
    else if(request.data.reqFrom===LOGIN_CLIENT_GROUP && request.data.groupId===LOGIN_CLIENT_GROUP) {
        // FROM CLIENT LOGIN - CLIENT PROFILE (ADD/EDIT FROM AFFILIATE CLIENT LISTING) 
        // +request.data.profileId 
        ENDPOINT = URL_BASE_API+'affiliate/dynamic-field/?search='+request.data.groupId+'&show_tab=true&column=display_order';  
    } 
    return service.get(ENDPOINT);     
}; 

export const dynamicFieldsMasterList = (request) => {
    // {groupId: 0, reqFrom:0}    
    let ENDPOINT = URL_BASE_API+'super-admin/dynamic-fields/?column=display_order&search='+request.data.groupId;
    return service.get(ENDPOINT);     
}; 

export const dynamicFieldsUpdate = (request) => {
  let ENDPOINT = '';
  if(request.data.reqFrom===LOGIN_SUPER_ADMIN_GROUP)
      ENDPOINT = URL_BASE_API+'super-admin/dynamic-fields/'+request.data.id;
  else if(request.data.reqFrom===LOGIN_AFFILIATE_GROUP)
      ENDPOINT = URL_BASE_API+'affiliate/dynamic-field/'+request.data.id; 
  delete request.data.reqFrom;  
  return service.put(ENDPOINT,request.data);
};

export const dynamicFieldsDataSave = (request) => {
    let ENDPOINT = '';
    if(request.data.reqFor===LOGIN_AFFILIATE_GROUP)
        ENDPOINT = URL_BASE_API+'user/dynamic-field-value/'+request.data.userProfileId; 
    else if(request.data.reqFor===LOGIN_CLIENT_GROUP || request.data.reqFor===LOGIN_CREW_GROUP)
        ENDPOINT = URL_BASE_API+'user/dynamic-field-client-crew-value/'+request.data.userProfileId+'?user_type_id='+request.data.user_type_id; 
    delete request.data.reqFor;  
    delete request.data.userProfileId
    return service.put(ENDPOINT,request.data);
};
  
